<template>
  <el-dialog
      :visible.sync="dialogVisible"
      class="root"
      width="750px">
    <div slot="title" class="title">
      {{ title }}
    </div>
    <template v-if="!showTable">
      <template slot="footer">
        <el-button type="primary" icon="el-icon-s-platform" @click="upsert">
          儲存
        </el-button>
      </template>
      <el-form label-width="120px" :model="checkinLog" :rules="rules" ref="ruleForm">
        <el-form-item label="員工" prop="employee">
          <div class="flex">
            <template v-if="checkinLog.employee">
              <span class="emp_str">{{ employeeStr }}</span>
            </template>
            <el-button type="primary" v-if="type === 'add' && !showTable" @click="showTable = true">
              選擇員工
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="打卡類型" prop="checkType">
          <el-radio-group id="checkType" v-model="checkinLog.check_type" @change="checkTypeChange">
            <el-radio label="P1">
              上下班打卡
            </el-radio>
            <br/>
            <el-radio label="P2">
              加班打卡
            </el-radio>
            <br/>
            <el-radio label="P3">
              出公差打卡
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="動作" prop="action">
          <el-radio-group id="action" v-model="checkinLog.action">
            <el-radio label="P0">
              未打卡動作
            </el-radio>
            <el-radio label="P1">
              上班
            </el-radio>
            <br/>
            <el-radio label="P2">
              下班
            </el-radio>
            <br/>
            <el-radio label="P3">
              加班開始打卡
            </el-radio>
            <br/>
            <el-radio label="P4">
              加班結束打卡
            </el-radio>
            <br/>
            <el-radio label="P5">
              出公差開始打卡
              <br/>
              <el-input id="place" v-model="checkinLog.place" maxlength="100" style="width: 200px;"/>
            </el-radio>
            <br/>
            <el-radio label="P6">
              出公差結束打卡
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="打卡時間" prop="chekcinDate">
          <el-date-picker id="checkinDate"
                      v-model="checkinLog.checkin_date" 
                      type="datetime" 
                      placeholder="請選擇" format="yyyy-MM-dd HH:mm:ss" style="width: 210px;" />
        </el-form-item>
        <el-form-item label="打卡" prop="checkStatus">
          <el-radio-group id="checkStatus" v-model="checkinLog.check_status">
            <el-radio label="P1">
              未打卡
            </el-radio>
            <br/>
            <el-radio label="P2">
              已打卡
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </template>
    <ezoom-table v-if="type === 'add' && showTable" :search="search" :data="employees" :columns="columns">
      <template slot="buttons">
        <el-input
            style="margin-left: 20px;width: 200px"
            v-model="search"
            size="mini"
            placeholder="搜尋"/>
      </template>
      <el-table-column
          fixed="left"
          label="操作"
          width="120">
        <template slot-scope="scope">
          <el-button @click.stop="select(scope.row)" type="success" size="small">選擇</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="department" sortable label="部門" width="200"/>
      <el-table-column prop="employeeId" sortable label="員工編號" width="200"/>
      <el-table-column prop="employeeName" sortable label="姓名"/>
    </ezoom-table>
  </el-dialog>
</template>

<script>
import {ref, computed} from "@vue/composition-api";
import EzoomTable from '@/components/EzoomTable.vue';

export default {
  name: "CrudCheckinLog",
  props: {
    employees: Array,
    addFn: Function,
    updateFn: Function,
  },
  components: {
    EzoomTable
  },
  setup() {

    const type = ref('');
    const employee = ref({});
    const checkinLog = ref({
      employee: null,
      check_type: 'P1',
      check_status: 'P1',
      action: 'P1',
      place: null,
      checkinDate: null
    });
    const dialogVisible = ref(false);

    const openDialog = (row, newType) => {

      if (newType === 'update') {

        employee.value = {
          id: row.employee_id,
          name: row.employee_name,
          department: row.department
        };

        checkinLog.value = {
          ...row,
          employee: employee.value
        };
        console.log(checkinLog.value);
      }

      type.value = newType;
      dialogVisible.value = true;
    };

    const checkTypeChange = () => {
      const checkType = checkinLog.value.checkType;
      const action = checkinLog.value.action;
      if (checkType === 'P1') {
        if (!(action === 'P1' || action === 'P2')) {
          checkinLog.value.action = 'P1';
        }
      } else if (checkType === 'P2') {
        if (!(action === 'P3' || action === 'P4')) {
          checkinLog.value.action = 'P3';
        }
      } else if (checkType === 'P3') {
        if (!(action === 'P5' || action === 'P6')) {
          checkinLog.value.action = 'P5';
        }
      } else {
        checkinLog.value.action = 'P0';
      }
    };

    const search = ref('');
    const showTable = ref(false);
    const columns = ref([
      {label: "員工編號", prop: "employeeId"},
      {label: "姓名", prop: "employeeName"},
      {label: "部門", prop: "department"},
    ]);

    const rules = ref({
      employee: [
        {required: true, message: '員工為必填欄位', trigger: 'change'},
      ],
      value: [
        {required: true, message: "體溫為必填欄位", trigger: "change"}
      ],
    });

    const title = computed(() => {

      if (showTable.value) return '選擇員工';
      else if (type.value === 'add') return '新增打卡回報紀錄';
      else if (type.value === 'update') return '修改打卡回報紀錄';
      else return '';
    });

    const employeeStr = computed(() => {

      const emp = checkinLog.value.employee;
      var s = emp.id ? `${emp.name}(${emp.department} - ${emp.id})` : '';
      console.log('employeeStr: ' + s);
      return s;
    });

    return {
      openDialog,
      checkTypeChange,
      search,
      rules,
      title,
      showTable,
      dialogVisible,
      columns,
      type,
      employeeStr,
      employee,
      checkinLog,
    };
  },
  methods: {
    select(row) {

      this.showTable = false;
      this.checkinLog.employee = {
        ...row,
        name: row.employeeName,
        department: row.department,
        id: row.employeeId
      }
    },
    getData() {

      return {
        check_type: this.checkinLog.check_type,
        action: this.checkinLog.action,
        place: this.checkinLog.place, 
        checkinDate: this.checkinLog.checkin_date,
        check_status: this.checkinLog.check_status,
        employee_id: this.checkinLog.employee.id,
        id: this.checkinLog.id,
      }
    },
    upsert() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.type === 'add' ? this.addFn(this.getData()).then(() => this.dialogVisible = false) : this.updateFn(this.getData()).then(() => this.dialogVisible = false)
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset(formName) {
      this.$refs[formName].resetFields();
    },
  },
  computed: {
    marks() {

      return {
      }
    },
  }
}
</script>

<style scoped>

.emp_str {
  padding-left: 10px;
  padding-right: 10px;
  font-size: 30px;
}

.root {
  text-align: left;
  font-weight: 900;
}

.title {
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  font-weight: bolder;
  margin-right: 30px;
}
</style>
